export default {
	events: [],
	totalEvents: 0,
};
